export default __webpack_public_path__ + "media/images/features/ja/flow_pc-f52b64a7b2a6dbf52e627fc9f19c1e35.png";